var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade", duration: { enter: 500, leave: 1000 } } },
    [
      _vm.isDisplayed
        ? _c("div", { staticClass: "initial-loader" }, [
            _c("img", {
              staticClass: "akkodis-rectangle",
              attrs: {
                src: require("@/common/assets/icons/akkodis-blue-square.svg")
              }
            }),
            _c("img", {
              staticClass: "akkodis-letter",
              attrs: {
                src: require("@/common/assets/icons/akkodis-logo-letter.svg")
              }
            }),
            _c("img", {
              staticClass: "drc-text",
              attrs: { src: require("@/common/assets/icons/drc-text.svg") }
            })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }